export default __webpack_public_path__ + "static/media/3435 knife block A top.6ea167c9.png";